export default __webpack_public_path__ + "static/media/zkSync.f330d04a.svg";